module.exports = __webpack_public_path__ + "static/img/1.c76a06b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/eng/1.png
// module id = l8cg
// module chunks = 0